import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  MicrosoftDialPlanFieldConfig,
  MicrosoftDialPlanGroupSearchResult,
} from '../../../shared/models/generated/ziroModels';

@Injectable()
export class MicrosoftDialPlansResource {
  private http = inject(HttpClient);

  getAllDialPlanGroups(tenantId: string | number): Observable<MicrosoftDialPlanFieldConfig[]> {
    return this.http.get<MicrosoftDialPlanFieldConfig[]>(
      `/services/microsoft/field-configs/tenants/${tenantId}/dial-plans`,
    );
  }

  getDialPlanInventoriesByLineUri(
    tenantId: string,
    e164LineUri: string,
    extension?: string,
  ): Observable<MicrosoftDialPlanGroupSearchResult[]> {
    let queryParams = `?lineUri=${encodeURIComponent(e164LineUri)}`;

    if (extension) {
      queryParams += `&extension=${encodeURIComponent(extension)}`;
    }

    return this.http.get<MicrosoftDialPlanGroupSearchResult[]>(
      `/services/microsoft/views/tenants/${tenantId}/dial-plan-inventories/search${queryParams}`,
    );
  }
}
